import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "ab-group-activity",
  templateUrl: "./group-activity.component.html",
})
export class GroupActivityComponent implements OnInit {
  @Input() public activity: any;
  @Input() public index: number;
  @Input() public nested: boolean;
  public showNested: boolean;
  public visibleSubActivities: any;

  public ngOnInit() {
    this.showNested = false;
  }

  public trackByTrackableId(_index: number, subActivity: any) {
    return subActivity.trackableId;
  }

  public toggleShowNested() {
    // This ensures we only render the subActivities when we need them.
    // Otherwise, it can have a huge performance impact.
    this.visibleSubActivities = this.activity.subActivities;
    this.showNested = !this.showNested;
  }
}
